/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-scrollable-container {
  background: #fff;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 2;
}
.ux-scrollable-container__track {
  background: #c5c5c5;
  border-radius: 30px;
  cursor: grab;
  display: block;
  height: 10px;
}
.ux-scrollable-container [data-scroll-target], .ux-scrollable-container__scroll {
  /* IE10+ */
  -ms-overflow-style: -ms-autohiding-scrollbar;
  overflow-x: auto;
  /* FireFox */
  scrollbar-width: none;
}
.ux-scrollable-container [data-scroll-target]::-webkit-scrollbar, .ux-scrollable-container__scroll::-webkit-scrollbar {
  /* Chrome, Safari, Edge */
  display: none;
}
.ux-scrollable-container--top {
  margin-bottom: 5px;
}
.ux-scrollable-container--bottom {
  margin-top: 5px;
}